import { useQuery } from '@hooks/reactQuery';

import { getKpiSettings } from '@api/kpi';

import { extractQueryParams } from '@utils/common';

import { EUserRoles, TVendorsValues } from '@enums/common';

import { KPI_SETTINGS } from '@constants/queryKeys';

interface UseQueryKpiSettingsReturn {
	maxSelection?: number | null;
	isLoadingKpiSettings: boolean;
}

export const useQueryKpiSettings = (vendor?: TVendorsValues): UseQueryKpiSettingsReturn => {
	const {
		data,
		isLoading: isLoadingKpiSettings,
		isFetching: isFetchingKpiSettings,
	} = useQuery<{ maxSelection: number | null }>({
		queryKey: [KPI_SETTINGS, vendor],
		queryFn: extractQueryParams(getKpiSettings),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		enabled: [vendor],
		refetchOnWindowFocus: false,
	});

	return {
		maxSelection: data?.maxSelection,
		isLoadingKpiSettings: isLoadingKpiSettings || isFetchingKpiSettings,
	};
};
